import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import { TextP, Article, IconWrapper, BoldStyled } from './styles'

const FeaturesPlateItemNew = ({ item, icon, itemsTotal, isTextWhite }) => (
  <Article {...{ itemsTotal }}>
    <IconWrapper>
      <Icon id={icon} />
    </IconWrapper>
    <BoldStyled
      {...{ isTextWhite }}
      dangerouslySetInnerHTML={{ __html: item.title }}
    />
    <TextP
      {...{ isTextWhite }}
      dangerouslySetInnerHTML={{ __html: item.description }}
    />
  </Article>
)

FeaturesPlateItemNew.propTypes = {
  icon: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  itemsTotal: PropTypes.number,
  isTextWhite: PropTypes.bool,
}

FeaturesPlateItemNew.defaultProps = {
  isTitleHidden: false,
  mobile: false,
  itemsTotal: 0,
}

export default FeaturesPlateItemNew
